import JSEncrypt from 'jsencrypt';

const PUB_KEY = `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAMD9vOY90kc4DiHSR2Vo/PncwVaeC2MdrfbHI8VJ6WFqYx/gtKq+1EeuqCAd0TPJHes9Jg7OS2TkOSYltRoNpjsCAwEAAQ==`;

export const encrypt = (text: string) => {
  const encrypt = new JSEncrypt({});
  encrypt.setPublicKey(PUB_KEY);
  return encrypt.encrypt(text);
};
